import { render, staticRenderFns } from "./BackgroundItemOverall.vue?vue&type=template&id=9fada63e&scoped=true&"
import script from "./BackgroundItemOverall.vue?vue&type=script&lang=js&"
export * from "./BackgroundItemOverall.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundItemOverall.vue?vue&type=style&index=0&id=9fada63e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fada63e",
  null
  
)

export default component.exports